import { Subject } from 'rxjs';
import CookieUtils from 'PyzShopUi/scripts/utils/cookieUtils';
import {
    SMART_SUGGEST_COOKIE_ENABLE_VALUE,
    SMART_SUGGEST_COOKIE_NAME
} from 'PyzShopUi/scripts/search-suggestion/constants';
import { DE_DOMAIN } from 'PyzShopUi/scripts/constants/common';

export const searchValueObserver = new Subject<string>();

export const isSmartSuggestEnable = () => {
    const enableSmartSuggestCookieValue: string = CookieUtils.getCookieValue(SMART_SUGGEST_COOKIE_NAME);
    const domain: string = document.documentElement.getAttribute('data-share-domain');

    return enableSmartSuggestCookieValue === SMART_SUGGEST_COOKIE_ENABLE_VALUE && domain === DE_DOMAIN;
}
